<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.75 1.5H14.25C14.6642 1.5 15 1.83579 15 2.25V16.6075C15 16.8145 14.8321 16.9825 14.625 16.9825C14.5546 16.9825 14.4855 16.9626 14.4258 16.9252L9 13.5235L3.57419 16.9252C3.39872 17.0352 3.16729 16.9822 3.05728 16.8067C3.01985 16.747 3 16.678 3 16.6075V2.25C3 1.83579 3.33579 1.5 3.75 1.5Z"
    fill="white"
  />
</svg>
